/**
 * 跳转
 * @param url 地址
 * @param newTagView 是否打开新的标签页
 */
export function toUrl(url, newTagView = 0) {
    if (newTagView) {
        window.open(url)
    } else {
        window.location.href = url
    }
}

export function openUrl(url, newTagView = true) {
    let reg = /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/;
    if (!reg.test(url)) {
        return
    }
    if (newTagView) {
        window.open(url)
    } else {
        window.location.href = url
    }
}
